import { Directive } from '@angular/core';

@Directive({
  selector: ':not(jd-row)[row],jd-row',
  host: {
    class: 'jd-row'
  }
})
export class JdRowDirective {

  constructor() {
  }

}
